import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Toaster from "./components/mui/Toaster";
import { useSelector } from "react-redux";
import { getParamFromUrl, setCookie } from "./utils/utils.js";
import { DEBUG } from "./store/enums";
import ErrorBoundary from "./components/mui/error_boundary/ErrorBoundary.jsx";
import "./style/common.scss";
import LoaderContainer from "./components/mui/loader_container/LoaderContainer.jsx";
import CommonModals from "./components/common_modals/CommonModals.jsx";
import Main from "./pages/main.jsx";
import BottomNavigation from "./components/bottom_navigation/BottomNavigation.jsx";
import NavigateOnLoad from "./NavigateOnLoad.jsx";

const Game = lazy(() => import("./pages/game"));
const BonusGame = lazy(() => import("./pages/bonusGame"));
const Games = lazy(() => import("./pages/games"));
const Terms = lazy(() => import("./pages/terms"));
const Banner = lazy(() => import("./pages/banner.jsx"));
const Promotions = lazy(() => import("./pages/promotions.jsx"));
const ConfirmEmail = lazy(() => import("./pages/confirmEmail.jsx"));
const NewPassword = lazy(() => import("./pages/newPassword.jsx"));
const Categories = lazy(() => import("./pages/categories.jsx"));
const WagerGames = lazy(() => import("./pages/wagerGames.jsx"));

export default function App() {
  const sessionId = getParamFromUrl("sessionId");
  const isTgBot = useSelector((state) => state.common.isTgBot);

  if (sessionId && isTgBot) {
    if (DEBUG) console.log("document.cookie", document.cookie);
    if (DEBUG) console.log("set cookie", sessionId);
    setCookie("_GCS_SID_", sessionId);
    if (DEBUG) console.log("document.cookie", document.cookie);
  }

  return (
    <BrowserRouter>
      <NavigateOnLoad />

      <Suspense fallback={<LoaderContainer fullHeight loader center />}>
        <Routes>
          <Route path="/game/:id" element={<Game />} />
          <Route path="/games/:id/:subId" element={<Games />} />
          <Route path="/games/:id" element={<Games />} />
          <Route path="/bonus_game/:id" element={<BonusGame />} />
          <Route path="/banner/:id" element={<Banner />} />
          <Route path="/confirm_email/:code" element={<ConfirmEmail />} />
          <Route path="/new_password/:code" element={<NewPassword />} />
          <Route path="/categories/:categoryId" element={<Categories />} />
          <Route path="/wager_games" element={<WagerGames />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/*" element={<Main />} />
        </Routes>
      </Suspense>

      <ErrorBoundary>
        <BottomNavigation />
      </ErrorBoundary>
      <CommonModals />
      <Toaster />
    </BrowserRouter>
  );
}
